export default "__VITE_ASSET__Cng3srZ5__"